import type { ISelectedTrip } from "@b2bportal/core-types";
import { FrozenProductEnum } from "@b2bportal/price-freeze-api";
import { createSelector } from "@reduxjs/toolkit";
import type { FlightsPriceFreezeState } from "../../../store";
import { getMatchedLatestTrip, getPriceFreezeTripDetails } from "../../details";

export const getExerciseSelectedProduct = createSelector(
  [getPriceFreezeTripDetails, getMatchedLatestTrip],
  (tripDetails, latestTrip) => {
    if (tripDetails == null || latestTrip == null) {
      return null;
    }
    const selectedFare = tripDetails.fareDetails.find(
      (fare) => fare.id === latestTrip.fareId
    );

    const selectedTrip = {
      tripId: latestTrip.tripId,
      outgoingFareId: latestTrip.fareId,
      outgoingSliceId: tripDetails.slices[0].id,
      outgoingFareRating: selectedFare?.slices?.[0]?.fareShelf?.rating,
      ...(tripDetails.slices.length > 1
        ? {
            tripId: latestTrip.tripId,
            returnFareId: latestTrip.fareId,
            returnSliceId: tripDetails.slices[1].id,
            returnFareRating: selectedFare?.slices?.[1]?.fareShelf?.rating,
          }
        : undefined),
    } satisfies ISelectedTrip;

    return { selectedTrip };
  }
);

export const getExerciseFrozenProduct = (state: FlightsPriceFreezeState) =>
  state.flightsPriceFreeze.details.voucher?.frozenProduct;

export const getExerciseSeatedPassengers = createSelector(
  [getExerciseFrozenProduct],
  (frozenProduct) => {
    if (
      frozenProduct == null ||
      frozenProduct.FrozenProduct !== FrozenProductEnum.Flight
    ) {
      return 0;
    }

    return (
      frozenProduct.passengerCount.numOfAdults +
      frozenProduct.passengerCount.numOfChildren +
      frozenProduct.passengerCount.numOfInfants
    );
  }
);
